import moment from "moment/moment";
import type { TFunction } from "react-i18next";
import type { Column } from "react-table";
import styled from "styled-components";
// import { RequestActionsCell } from "../components/tables/RequestActionsCell";
import { RequestActionsCell} from "../components/tables/RequestActions";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "@/lib/utils";


 export enum APPROVAL_STATUS {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  REVOKED = "REVOKED",
  PROCESSING = "PROCESSING"
}

const ColoredSpan = styled.span`
  color: ${({ color }) => color};
`;

const getStatusColor = (status: string): string => {
	switch (status) {
    case APPROVAL_STATUS.PROCESSING:
      return "var(--textColor)";
		case APPROVAL_STATUS.APPROVED:
			return "#4AB0A6";
		case APPROVAL_STATUS.DECLINED:
			return "orange";
		case APPROVAL_STATUS.PENDING:
			return "var(--textColor)";
		case APPROVAL_STATUS.REVOKED:
			return "#EC3D08";
    default:
      return "#4AB0A6";
	}
};
const ApprovalStatus = ({
	approvalStatus,
}: {
	approvalStatus: string;
	translation: TFunction;
}): JSX.Element => (
	<ColoredSpan {...{ color: getStatusColor(approvalStatus) }}>
		{approvalStatus}
	</ColoredSpan>
);

export const getAccessRequestsTableColumnConfig = (
	t: TFunction,
): Column<Request>[] => [
	{
		Header: t("request.Id"),
		accessor: "id",
		Cell: (props: { row: { original: Request } }) => {
      const { id } = props.row.original;
      return <Link to={`/requests/${id}`}><span>{id || ""}</span></Link>
    },
	},
	{
		Header: t("team.name.label"),
		accessor: "institutionName",
		Cell: (props: { row: { original: Request } }) => {
      const { id, institutionName } = props.row.original;
      return <Link to={`/requests/${id}`}><span>{institutionName || ""}</span></Link>
    },
	},
	{
		Header: t("client.email"),
		accessor: "clientEmailAddress",
		Cell: (props: { row: { original: Request } }) => {
      const { id, clientEmailAddress } = props.row.original;
      return <Link to={`/requests/${id}`}><span>{clientEmailAddress || ""}</span></Link>
    },
	},
	{
		Header: t("client.Id"),
		accessor: "clientId",
    Cell: (props: { row: { original: Request } }) => {
      const { id, clientId } = props.row.original;
      return <Link to={`/requests/${id}`}><span>{clientId || ""}</span></Link>
    },
	},
	{
		Header: t("request.time"),
		accessor: "createdAt",
    Cell: (props: { row: { original: Request } }) => {
      const { id, createdAt } = props.row.original;
      return <Link to={`/requests/${id}`}><span>{moment(createdAt).format("DD-MM-YYYY, h:mm:ss a")}</span></Link>
    },
	},
	{
		Header: t("statuses"),
		accessor: "status",
		Cell: ({ value }: { value: string }) => (
			<ApprovalStatus approvalStatus={capitalizeFirstLetter(value)} translation={t} />
		),
		disableSortBy: true,
	},
	{
		Header: t("actions.title"),
		Cell: (props: { row: { original: Request } }) => (
			<RequestActionsCell data={props.row.original} />
		),
		disableSortBy: true,
	},
];
